import Application from "../../Application";
import LoginPresenter, {
  ILoginPresenter
} from "../../presenter/authentication/LoginPresenter";

export default class ShowLoginInteractor {
  private application: Application;
  private output?: ILoginPresenter;

  constructor(application) {
    this.application = application;
  }

  execute(username?: string, redirect?: string) {
    this.output = LoginPresenter({
      application: this.application,
      initialState: {
        username: username || "",
        password: "",
        loginButtonDisabled: true,
        redirectRoute: redirect
      }
    });

    return this.output;
  }
}
